import { categories } from '@/mocks/comics';

interface CategoriesProps {
  onSelect: (cate: string) => void;
}

export default function Categories({ onSelect }: CategoriesProps) {
  return (
    <section id="categories" className="relative bg-background-100/40 py-16 md:py-24">
      <div className="container-site">
        <div className="reveal mx-auto max-w-2xl text-center">
          <span className="text-xs font-medium uppercase tracking-[0.3em] text-primary-400">
            主题分类
          </span>
          <h2 className="mt-3 font-heading text-3xl text-foreground-950 md:text-4xl">
            六大主题，总能找到想一起看的那部
          </h2>
          <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">
            按你喜欢的题材挑一部，点进对应分类即可进入一起看漫画专区筛选同好作品。
          </p>
        </div>

        <div className="mt-12 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {categories.map((cat, idx) => (
            <button
              key={cat.name}
              type="button"
              onClick={() => {
                onSelect(cat.name);
                document
                  .querySelector('#hot')
                  ?.scrollIntoView({ behavior: 'smooth' });
              }}
              className={`reveal group relative h-52 overflow-hidden rounded-2xl text-left transition-all hover:-translate-y-1`}
              style={{ transitionDelay: `${(idx % 3) * 80}ms` }}
              aria-label={`查看${cat.name}分类的漫画`}
            >
              <img
                src={cat.image}
                alt={`${cat.name}分类漫画配图，可在此分类下和漫友一起看`}
                className="absolute inset-0 h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-background-50/95 via-background-50/50 to-background-50/10"></div>
              <div className="relative flex h-full flex-col justify-end p-5">
                <div className="flex items-center gap-2.5">
                  <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-primary-500/20 text-primary-300 backdrop-blur">
                    <i className={`${cat.icon} text-xl`}></i>
                  </span>
                  <div>
                    <h3 className="font-heading text-xl text-foreground-950">{cat.name}</h3>
                    <p className="text-xs text-foreground-500">{cat.count} 部作品</p>
                  </div>
                  <span className="ml-auto flex h-9 w-9 items-center justify-center rounded-full border border-background-300/60 text-foreground-600 transition-colors group-hover:bg-primary-500 group-hover:text-background-50 group-hover:border-primary-500">
                    <i className="ri-arrow-right-up-line"></i>
                  </span>
                </div>
                <p className="mt-3 hidden text-xs text-foreground-400 sm:block">{cat.desc}</p>
              </div>
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}